import loadSingleProductTileDynamicModule from './modules/SingleProductTile.module';
import loadWishListModule from './modules/WishList.module';
import loadBasketModule from './modules/Basket.module';
import loadCompareModule from './modules/Compare.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadSingleProductTileModule = () => ({
    hasRouter: false,
    modules: [
        loadWishListModule(),
        loadSingleProductTileDynamicModule(),
        loadBasketModule(),
        loadDeliveryPromiseModule(),
        loadCompareModule(),
    ],
});
export default loadSingleProductTileModule;
